import { Injectable } from '@angular/core';
import { EntityState, EntityStore } from '@examdojo/state';
import { PayoutRequestStoreModel } from './payout-request.model';

export interface PayoutRequestState extends EntityState<PayoutRequestStoreModel> {}

@Injectable({
  providedIn: 'root',
})
export class PayoutRequestStore extends EntityStore<PayoutRequestState, PayoutRequestStoreModel, 'id'> {
  constructor() {
    super({
      name: 'payout-requests',
      idKey: 'id',
      initialPropsState: {},
    });
  }
}
